import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordVisit } from '../lib/siteVisits';

// Counts each page view for the admin "Visitas web" tab. Renders nothing.
export default function VisitTracker() {
  const { pathname } = useLocation();
  useEffect(() => { recordVisit(pathname); }, [pathname]);
  return null;
}
